export class Workspace {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "cloud",
            "baseName": "cloud",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "WorkspaceStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "WorkspaceAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "WorkspaceGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Workspace.attributeTypeMap;
    }
    constructor() {
    }
}
